/**
 * Sharing windows
 */

import $ from 'jquery';

const sharing = {
  initSharing: () => {
    const modal = $('#shareModal');
    const copyLink = modal.find('.copy-link');
    const emailLink = modal.find('.email-link');
    const socialShare = modal.find('.social-share');

    copyLink.on('click', function (e) {
      e.preventDefault();
      sharing.copyLink();
    });

    emailLink.on('click', function () {
      sharing.closeModal();
    });

    socialShare.on('click', function (e) {
      e.preventDefault();
      window.open(
        $(this).attr('href'),
        'ShareWindow',
        'height=450, width=550, top=' +
          ($(window).height() / 2 - 275) +
          ', left=' +
          ($(window).width() / 2 - 225) +
          ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
      );
      return false;
    });
  },
  copyLink: () => {
    const text = window.location.href;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      document.execCommand('copy');
    }
  },
  closeModal: () => {
    const modal = $('#shareModal');
    const modalBackdrop = $('.modal-backdrop');

    modal.removeClass('show');
    modalBackdrop.removeClass('show');
  },
};

export default sharing;
